import React from 'react';
import { bandClasses, scoreBand, type Bands } from '../../utils/scoring';
import { cn } from '../../utils/cn';
interface ScoreChipProps {
  score: number;
  bands?: Bands;
  showBand?: boolean;
  className?: string;
}
export function ScoreChip({
  score,
  bands,
  showBand = false,
  className
}: ScoreChipProps) {
  const band = scoreBand(score, bands);
  return <span className={cn('inline-flex items-center gap-1.5 rounded-sm border px-1.5 py-0.5 font-mono text-[11px]', bandClasses(band), className)} data-id="element-406" data-mp="36ynxcf6jzm1l">
      {score.toFixed(1)}
      {showBand && <span className="font-heading text-[10px] uppercase tracking-wide" data-id="element-407" data-mp="2s41bzgohsppz">
          {band === 'auto-advance' ? 'advance' : band === 'manual-review' ? 'review' : 'decline'}
        </span>}
    </span>;
}